import React from 'react';
import classNames from 'classnames';

import InputAdornment from "@material-ui/core/InputAdornment";
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ReactTooltip from 'react-tooltip';
import { FaInfoCircle } from 'react-icons/fa';


const Receptors = props => (
    <div className="form-input-container">
        <div>
            <b>Receptors <FaInfoCircle data-tip data-for='receptors'/> </b>

            <ReactTooltip id='receptors' place="right" type="light" effect="solid">
                <i>NOTE: To use only 2 nested grids change grid 3 horizontal spacing to 0.  </i>
                AERMAP is split and run in paralell greatly reducing run time. As a result, Grid 1 and Grid 2 horizontal spacing is not changeable.
            </ReactTooltip>
        </div>

        <div className={classNames(props.classes.margin)} >

            Grid 1:
            <FormControl className={classNames(props.classes.margin)} style={{minWidth: '200px', maxWidth: '30%', paddingLeft: '20px'}}>
                <InputLabel style={{paddingLeft: '20px'}}>Lower Boundary</InputLabel>
                <Input
                    inputProps={{ min: "0", max: "500", step: "10" }}
                    type="number"
                    name="grid1LowerBoundary"
                    value={props.grid1LowerBoundary}
                    //onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">m</InputAdornment>}/>

            </FormControl>
            <FormControl className={classNames(props.classes.margin)} style={{minWidth: '200px', maxWidth: '30%'}}>

                <InputLabel>Upper Boundary</InputLabel>
                <Input
                    inputProps={{ min: "500", max: "2000", step: "100" }}
                    type="number"
                    name="grid1UpperBoundary"
                    value={props.grid1UpperBoundary}
                    onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">m</InputAdornment>}/>
            </FormControl>
            <FormControl className={classNames(props.classes.margin)} style={{minWidth: '200px', maxWidth: '30%'}}>

                <InputLabel>Horizontal Spacing</InputLabel>
                <Input
                    inputProps={{ min: "50", max: "500", step: "50" }}
                    type="number"
                    name="grid1Spacing"
                    value={props.grid1Spacing}
                    //onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">m</InputAdornment>}/>
            </FormControl>
        </div>
        <div className={classNames(props.classes.margin)} >
            Grid 2:
            <FormControl className={classNames(props.classes.margin)} style={{minWidth: '200px', maxWidth: '30%', paddingLeft: '20px'}}>
                <InputLabel style={{paddingLeft: '20px'}}>Lower Boundary</InputLabel>
                <Input
                    inputProps={{ min: "500", max: "2000", step: "100" }}
                    type="number"
                    name="grid1UpperBoundary"
                    value={props.grid1UpperBoundary}
                    onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">m</InputAdornment>}/>
            </FormControl>
            <FormControl className={classNames(props.classes.margin)} style={{minWidth: '200px', maxWidth: '30%'}}>
                <InputLabel>Upper Boundary</InputLabel>
                <Input
                    inputProps={{ min: "2000", max: "10000", step: "100" }}
                    type="number"
                    name="grid2UpperBoundary"
                    value={props.grid2UpperBoundary}
                    onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">m</InputAdornment>}/>
            </FormControl>
            <FormControl className={classNames(props.classes.margin)} style={{minWidth: '200px', maxWidth: '30%'}}>
                <InputLabel>Horizontal Spacing</InputLabel>
                <Input
                    inputProps={{ min: "0", max: "100", step: "100" }}
                    type="number"
                    name="grid2Spacing"
                    value={props.grid2Spacing}
                    //onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">m</InputAdornment>}/>
            </FormControl>
        </div>
        <div className={classNames(props.classes.margin)} >
            Grid 3:
            <FormControl className={classNames(props.classes.margin)} style={{minWidth: '200px', maxWidth: '30%', paddingLeft: '20px'}}>
                <InputLabel style={{paddingLeft: '20px'}}>Lower Boundary</InputLabel>
                <Input
                    inputProps={{ min: "2000", max: "10000", step: "100" }}
                    type="number"
                    name="grid2UpperBoundary"
                    value={props.grid2UpperBoundary}
                    onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">m</InputAdornment>}/>
            </FormControl>
            <FormControl className={classNames(props.classes.margin)} style={{minWidth: '200px', maxWidth: '30%'}}>
                <InputLabel>Upper Boundary</InputLabel>
                <Input
                    inputProps={{ min: "10000", max: "50000", step: "100" }}
                    type="number"
                    name="grid3UpperBoundary"
                    value={props.grid3UpperBoundary}
                    onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">m</InputAdornment>}/>
            </FormControl>
            <FormControl className={classNames(props.classes.margin)} style={{minWidth: '200px', maxWidth: '30%'}}>
                <InputLabel>Horizontal Spacing</InputLabel>
                <Input
                    inputProps={{ min: "0", max: "1000", step: "1000" }}
                    type="number"
                    name="grid3Spacing"
                    value={props.grid3Spacing}
                    onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">m</InputAdornment>}/>
            </FormControl>
        </div>
    </div>
)
export default Receptors;
